import { Divider } from "@mui/material";

export const TermsContent = () => {
	return (
		<div
			style={{
				maxWidth: "800px",
				margin: "0 auto",
				padding: "20px",
				fontFamily: "Arial, sans-serif",
				color: "#000",
				lineHeight: "1.6",
			}}
		>
			<p style={{ marginBottom: "20px" }}>
				<b>Effective Date:</b> March 24, 2025
			</p>

			<p style={{ marginBottom: "20px" }}>
				Welcome to In-House Health, an AI-driven scheduling and management platform for modern healthcare teams. By accessing or using our platform, you agree
				to be bound by the following terms and conditions. Please read them carefully before proceeding.
			</p>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>1. Acceptance of Terms</h3>
			<p style={{ marginBottom: "20px" }}>
				These Terms and Conditions ("Terms") govern your access and use of the In-House Health platform (the "Platform"). By creating an account or using the
				Platform, you signify your agreement to these Terms. If you do not agree, do not use the Platform.
			</p>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>2. Individual Login Credentials</h3>
			<h4 style={{ marginTop: "20px" }}>2.1 Unique Login Requirements:</h4>
			<p style={{ marginBottom: "20px" }}>
				Each user is required to create and maintain their individual login credentials for the Platform. Sharing login credentials with others is strictly
				prohibited.
			</p>
			<h4 style={{ marginTop: "20px" }}>2.2 Account Security:</h4>
			<p style={{ marginBottom: "20px" }}>
				You are responsible for maintaining the confidentiality of your login credentials. Unauthorized use of your account must be reported to In-House Health
				immediately.
			</p>
			<h4 style={{ marginTop: "20px" }}>2.3 Prohibited Actions:</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Share your username, password, or other login details with anyone.</li>
				<li>Permit others to access the Platform using your credentials.</li>
			</ul>
			<p style={{ marginBottom: "20px" }}>Failure to comply with this section may result in suspension or termination of your account.</p>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>3. Confidentiality and Privacy</h3>
			<h4 style={{ marginTop: "20px" }}>3.1 Confidentiality of Platform and Data:</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Copy, share, or disclose information about the Platform's technology, interface, or functionality without prior written consent.</li>
				<li>Use the Platform for any purpose other than its intended use.</li>
			</ul>
			<h4 style={{ marginTop: "20px" }}>3.2 Protected Health Information (PHI):</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Use PHI solely for authorized purposes within the scope of your role and responsibilities.</li>
				<li>
					Adhere to administrative, physical, and technical safeguards outlined by HIPAA to protect PHI against unauthorized access, disclosure, alteration, or
					destruction.
				</li>
				<li>Notify In-House Health immediately if you suspect a breach or unauthorized use/disclosure of PHI.</li>
			</ul>
			<h4 style={{ marginTop: "20px" }}>3.3 Data Security Measures:</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Access the Platform only from secure devices with up-to-date security protocols, including antivirus and encryption tools.</li>
				<li>Use strong passwords and enable multifactor authentication where applicable.</li>
			</ul>
			<h4 style={{ marginTop: "20px" }}>3.4 Confidentiality of User and Patient Data:</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Only share or access data in accordance with organizational policies and applicable laws.</li>
				<li>Avoid using unsecured methods to transfer sensitive information.</li>
			</ul>
			<h4 style={{ marginTop: "20px" }}>3.5 Third-Party Sharing Prohibition:</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Share PHI, patient, user, or business data obtained through the Platform with unauthorized parties.</li>
				<li>Use or disclose data in violation of HIPAA, HITRUST, or other applicable regulations.</li>
			</ul>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>4. Platform Use and Restrictions</h3>
			<h4 style={{ marginTop: "20px" }}>4.1 Permitted Use:</h4>
			<p style={{ marginBottom: "20px" }}>The Platform is designed exclusively for healthcare scheduling, team management, and associated workflows.</p>
			<h4 style={{ marginTop: "20px" }}>4.2 Prohibited Actions:</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Reverse-engineer, disassemble, or modify the Platform.</li>
				<li>Use the Platform for unlawful activities.</li>
				<li>Introduce malware, viruses, or any harmful components.</li>
			</ul>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>5. Breach Notification and Compliance</h3>
			<h4 style={{ marginTop: "20px" }}>5.1 Incident Reporting:</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Notify In-House Health within 24 hours of discovering the incident.</li>
				<li>Cooperate fully with any investigations or corrective measures undertaken.</li>
			</ul>
			<h4 style={{ marginTop: "20px" }}>5.2 Compliance Obligations:</h4>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Adhere to HITRUST and HIPAA standards while using the Platform.</li>
				<li>Review and acknowledge training on HIPAA, PHI, and data security as required.</li>
			</ul>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>6. Termination</h3>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Violation of these Terms.</li>
				<li>Unauthorized or fraudulent use of the Platform.</li>
			</ul>
			<p style={{ marginBottom: "20px" }}>
				In-House Health reserves the right to terminate or suspend your account at any time for the above reasons. Upon termination, all rights granted under
				these Terms will immediately cease.
			</p>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>7. Limitation of Liability</h3>
			<ul style={{ marginBottom: "20px", paddingLeft: "20px" }}>
				<li>Damages arising from your use of or inability to use the Platform.</li>
				<li>Unauthorized access to your account due to failure to comply with Section 2.</li>
			</ul>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>8. Changes to Terms</h3>
			<p style={{ marginBottom: "20px" }}>
				We may update these Terms from time to time. Continued use of the Platform after changes constitutes acceptance of the revised Terms.
			</p>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>9. Governing Law</h3>
			<p style={{ marginBottom: "20px" }}>These Terms are governed by and construed in accordance with the laws of the State of Delaware.</p>
			<Divider />
			<h3 style={{ marginTop: "30px" }}>Contact Us</h3>
			<p style={{ marginBottom: "20px" }}>If you have any questions or concerns about these Terms, please contact us at: hello@inhouse.health .</p>
			<Divider />
			<p style={{ marginBottom: "20px" }}>By accessing and using the Platform, you acknowledge that you have read, understood, and agreed to these Terms.</p>
		</div>
	);
};
